import React from 'react';
import { ArrowRight } from 'lucide-react';
import { villaImages } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const VillasSection = () => {
  const { language } = useLanguage();
  
  const whatsappNumber = "18097656789";
  const whatsappMessage = language === 'es' 
    ? "Hola, estoy interesado en información sobre las villas de lujo en República Dominicana."
    : "Hello, I'm interested in information about luxury villas in the Dominican Republic.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="villas" className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            {villaImages.map((image, index) => (
              <div
                key={index}
                className="aspect-[4/3] overflow-hidden rounded-lg shadow-md"
              >
                <img
                  src={image}
                  alt={`Villa ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-teal-500 mb-6">
              {language === 'es' ? 'Reservación de Villas' : 'Villa Reservations'}
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              <strong className="text-gray-800">
                {language === 'es' ? 'Increíbles Villas de lujo en Alquiler' : 'Amazing Luxury Villas for Rent'}
              </strong>{' '}
              {language === 'es' ? 'para disfrutar unas vacaciones de ensueño' : 'to enjoy a dream vacation'}{' '}
              <strong className="text-gray-800">
                {language === 'es' ? 'en República Dominicana.' : 'in the Dominican Republic.'}
              </strong>
            </p>
            <a 
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-medium px-6 py-3 rounded transition-colors group"
            >
              <span>{language === 'es' ? 'MÁS Información' : 'More Information'}</span>
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VillasSection;
